import { render, staticRenderFns } from "./show_info.vue?vue&type=template&id=95cd93a8&scoped=true&"
import script from "./show_info.vue?vue&type=script&lang=js&"
export * from "./show_info.vue?vue&type=script&lang=js&"
import style0 from "./show_info.vue?vue&type=style&index=0&id=95cd93a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd93a8",
  null
  
)

export default component.exports